<template>
  <div>
    <b-table
      ref="table"
      fixed
      hover
      foot-clone
      small
      :fields="fields"
      :items="form.detailedSupplies"
      caption-top
    >
      <template v-slot:cell(action)="data">
        <b-col cols="12" sm="12" md="12" lg="12">
          <a
            href="#"
            v-if="!data.item.selected"
            @click.prevent="editRow(data.item)"
            class="text-black-50"
            ><i class="fa fa-edit fa-lg mr-2" />
          </a>
          <a
            href="#"
            @click.prevent="deleteRow(data.item)"
            class="text-black-50"
            ><i class="fa fa-close text-danger fa-lg mr-2"></i>
          </a>
          &nbsp;
        </b-col>
      </template>

      <template v-slot:foot(index)="data">
        <span></span>
      </template>

      <template v-slot:foot(supplyfamily.name)="data">
        <span></span>
      </template>

      <template v-slot:foot(supply.text)="data">
        <span>TOTALES</span>
      </template>

      <template v-slot:foot(quantity)="data">
        <span>{{ totalQuantity }}</span>
      </template>

      <template v-slot:foot(unit_price)="data">
        <span></span>
      </template>

      <template v-slot:foot(total_price)="data">
        <span>{{ totalTotalPrice }}</span>
      </template>
    </b-table>

    <create-detailed-supplies-modal
      ref="CreateDetailedSuppliesContentTable"
      :form="form"
      :supplyfamilyOptions="supplyfamilyOptions"
    />
  </div>
</template>

<script>
import CreateDetailedSuppliesModal from "./CreateDetailedSuppliesModal.vue";

import { mapState, mapActions, mapGetters } from "vuex";
import numeral from "numeral";

export default {
  name: "createContentTable",
  props: {
    form: {
      type: Object,
      default: {}
    },
    supplyfamilyOptions: {
      type: Object,
      default: {}
    }
  },
  components: {
    CreateDetailedSuppliesModal
  },
  created() {},
  data() {
    return {
      fields: [
        { key: "index", label: "#" },
        { key: "supplyfamily.name", label: "Familia de Material" },
        { key: "supply.text", label: "Material" },
        { key: "quantity", label: "Cantidad" },
        { key: "unit_price", label: "Precio Unitario" },
        { key: "total_price", label: "Precio Total" },
        { key: "action", label: "" }
      ]
    };
  },
  computed: {
    totalQuantity() {
      return this.form.detailedSupplies.reduce(
        (total, item) => total + parseInt(item.quantity),
        0
      );
    },
    totalUnitPrice() {
      return parseFloat(
        this.form.detailedSupplies.reduce(
          (total, item) => total + parseFloat(item.unit_price),
          0
        )
      ).toFixed(2);
    },
    totalTotalPrice() {
      return parseFloat(
        this.form.detailedSupplies.reduce(
          (total, item) => total + parseFloat(item.total_price),
          0
        )
      ).toFixed(2);
    }
  },
  filters: {
    num_format(value) {
      value = parseFloat(value);
      return numeral(value).format("0,0.00");
    }
  },
  methods: {
    editRow(row) {
      this.$refs.CreateDetailedSuppliesContentTable.modalShown = true;
      this.$refs.CreateDetailedSuppliesContentTable.selectedRow = row;
    },
    deleteRow(row) {
      let deleteIndex = this.form.detailedSupplies.findIndex(
        item => item.index === row.index
      );
      this.form.detailedSupplies.splice(deleteIndex, 1);
      this.OrderIndex();
    },
    OrderIndex() {
      for (let index in this.form.detailedSupplies) {
        let new_index = parseInt(index) + parseInt(1);
        this.form.detailedSupplies[index].index = new_index;
      }
    }
  },
  mounted() {}
};
</script>

<style scoped></style>
